/**
 * Chip that indicates the trigger event type.
 */
import {Colors, hexToRGB} from '@wandb/common/css/globals.styles';
import React from 'react';

import {Chip} from '../Chip';
import {EventTriggeringConditionType} from './TriggerEventTypes';

type EventTypeChipProps = {
  eventType: EventTriggeringConditionType;
};

export const EventTypeChip = ({eventType}: EventTypeChipProps) => {
  switch (eventType) {
    case EventTriggeringConditionType.CreateArtifact: {
      return (
        <div style={{marginLeft: '-4px'}}>
          <Chip
            icon="versions-layers"
            label="Version"
            tooltip="Log a new version to artifact"
            color={Colors.MAGENTA_DARK}
            backgroundColor={hexToRGB(Colors.MAGENTA_LIGHT, 0.16)}
          />
        </div>
      );
    }
    case EventTriggeringConditionType.LinkModel: {
      return (
        <div style={{marginLeft: '-4px'}}>
          <Chip
            icon="model"
            label="Registry"
            tooltip="Link a new version to registered model"
            color={Colors.TEAL_DARK}
            backgroundColor={Colors.TEAL_TRANSPARENT}
          />
        </div>
      );
    }
    case EventTriggeringConditionType.AddArtifactAlias: {
      return (
        <div style={{marginLeft: '-4px'}}>
          <Chip
            icon="email-at"
            label="Alias"
            tooltip="Add an alias to an artifact version"
            color={Colors.SIENNA_DARK}
            backgroundColor={Colors.SIENNA_TRANSPARENT}
          />
        </div>
      );
    }
    // Update alias triggers have been deprecated
    case EventTriggeringConditionType.UpdateArtifactAlias: {
      return (
        <div style={{marginLeft: '-4px'}}>
          <Chip
            icon="email-at"
            label="Alias"
            tooltip="Update an alias on an artifact version"
            color={Colors.SIENNA_DARK}
            backgroundColor={Colors.SIENNA_TRANSPARENT}
          />
        </div>
      );
    }
    default: {
      console.warn('Invalid trigger event type');
      break;
    }
  }
  return null;
};
